<template>
    <section class="parallax first-widget" :style="{backgroundImage : 'url('+image+')'}">
	    <div :class="overlay ? 'parallax-overlay' : ''">
		    <div class="container" :class="classes ? classes : ''">
		        <slot name="content"></slot>
		    </div> <!-- /.container -->
	    </div> <!-- /.parallax-overlay -->
    </section> <!-- /#homeIntro -->
</template>

<script>
export default {
    name: 'parallax',
    props: ['overlay', 'image', 'classes']
}
</script>
